// extracted by mini-css-extract-plugin
module.exports = {"amazon":"amazon-uk-special-content_amazon__bvm9D"};